import { storage } from 'APP/packages/storage';
import { DEFAULT_CHAT_BACKGROUND } from 'APP/store/Appearance/Appearance.contants';
import Entities from 'STORE';

import { deleteChatBackgroundForEntity } from './deleteChatBackgroundForEntity';
import { setGlobalChatBackground } from './setGlobalChatBackground';

export function deleteCustomChatBackground(backgroundId: string): void {
  const userId = Entities.usersStore.myId;
  if (userId) {
    storage.chatBackgroundsCustom.remove(backgroundId, userId);
    Entities.appearance.deleteCustomChatBackground(backgroundId);

    const globalChatBackground = Entities.appearance.getChatBackgroundForEntity();
    if (globalChatBackground.background === backgroundId) {
      setGlobalChatBackground(DEFAULT_CHAT_BACKGROUND);
    }
    const chatBackgroundsByEntity = storage.chatBackgroundsByEntity.get(userId);
    Object.entries(chatBackgroundsByEntity).forEach(([entityId, background]) => {
      if (background.background === backgroundId) {
        deleteChatBackgroundForEntity(entityId);
      }
    });
  }
}
